import { useRef, useEffect } from "react";

/**
 * Custom hook that allows a function to be run when a click occurs outside a component.
 * @param callback - function to call when a click occurs outside the component
 * @param reference - (optional) pass in an existing ref to the element/component. If not provided, use the return
 *                  value from this hook as the ref for the element.
 */
export const useOutsideClick = (callback, reference?) => {
    const ref = reference? reference : useRef<any>();

    useEffect(() => {
        const handleClick = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                callback();
            }
        };

        document.addEventListener('click', handleClick, true);

        return () => {
            document.removeEventListener('click', handleClick, true);
        };
    }, [ref]);

    return ref;
};
